export function animateCountUp(
  target: number,
  onUpdate: (value: number) => void,
  delayMs = 0,
  durationMs = 800,
  onComplete?: () => void
): void {
  const start = performance.now();

  const step = (now: number) => {
    const progress = Math.min(1, (now - start) / durationMs);
    const eased = 1 - Math.pow(1 - progress, 3);
    onUpdate(target * eased);
    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      onComplete?.();
    }
  };

  setTimeout(() => requestAnimationFrame(step), delayMs);
}
